"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviousSAOMarketDate = exports.getPreviousUSMarketDate = exports.isLuxUSEarlyClose = exports.isLuxCAHoliday = exports.isLuxUSHoliday = exports.isLuxCAMarketClosed = exports.isLuxBrazilMarketClosed = exports.isLuxUSMarketClosed = exports.getCryptoMarketStatus = exports.getCAMarketStatus = exports.getBrazilMarketStatus = exports.getUSMarketStatus = exports.mostRecentMarketDay = exports.getTodayMarketOpenClose = exports.getLastMarketDay = exports.getMarketStatus = exports.MarketStatus = exports.getPreviousMarketDate = exports.isLuxHalfHoliday = exports.isLuxMarketClosed = exports.isLuxHoliday = exports.luxSAO = exports.luxEST = exports.momentToLux = exports.isLuxWeekend = exports.LUX_FORMATS = void 0;
var luxon_1 = require("luxon");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var luxMarkets_1 = require("./luxMarkets");
var index_1 = require("../index");
exports.LUX_FORMATS = {
  ATOM_DEF: 'LL/dd/yy',
  YYYY_MM_DD: 'yyyy-LL-dd',
  MM_DD_YYYY: 'MM-dd-yyyy',
  H_AM_PM: 'h a',
  H: 'H',
  H_MM_AM_PM: 'h:mm a',
  MMM_DD: 'MMM dd',
  MMMM_YYYY: 'MMMM yyyy',
  YYYY: 'yyyy',
  MMM_YYYY: 'MMM yyyy'
};
var isLuxWeekend = function isLuxWeekend() {
  var luxDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : luxon_1.DateTime.local();
  return [6, 7].includes(luxDate.weekday);
};
exports.isLuxWeekend = isLuxWeekend;
/**
 * This is for backwards compatibility, please just use a Luxon in the first place.
 * @param date The moment to be converted to a Luxon DateTime.
 * @returns A Luxon DateTime if 'date' is a moment. Otherwise returns 'date' unchanged.
 */
var momentToLux = function momentToLux(date) {
  return moment_timezone_1.default.isMoment(date) ? luxon_1.DateTime.fromMillis(date.valueOf()) : date;
};
exports.momentToLux = momentToLux;
var luxEST = function luxEST() {
  var luxDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : luxon_1.DateTime.local();
  return luxDate.setZone('America/New_York');
};
exports.luxEST = luxEST;
var luxSAO = function luxSAO() {
  var luxDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : luxon_1.DateTime.local();
  return luxDate.setZone('America/Sao_Paulo');
};
exports.luxSAO = luxSAO;
/**
 * Ignores the time of day! Does NOT include half holidays.
 * @returns true if the given DAY is a US holiday.
 */
var isLuxHoliday = function isLuxHoliday(market, luxDate) {
  luxDate = luxDate !== null && luxDate !== void 0 ? luxDate : (0, luxMarkets_1.luxMarket)(market).localTime();
  var ds = luxDate.toFormat('yyyy-LL-dd');
  return (0, luxMarkets_1.luxMarket)(market).fullHolidays.has(ds);
};
exports.isLuxHoliday = isLuxHoliday;
/**
 * Ignores the time of day! Does NOT include half holidays.
 * @returns true if the given DAY is a US holiday or weekend.
 */
var isLuxMarketClosed = function isLuxMarketClosed(market, luxDate) {
  if (market === 'CRYPTO') return false;
  luxDate = luxDate !== null && luxDate !== void 0 ? luxDate : (0, luxMarkets_1.luxMarket)(market).localTime();
  return (0, exports.isLuxHoliday)(market, luxDate) || (0, exports.isLuxWeekend)(luxDate);
};
exports.isLuxMarketClosed = isLuxMarketClosed;
/**
 * Ignores the time of day!
 * @returns true on a late-open or early-close DAY.
 */
var isLuxHalfHoliday = function isLuxHalfHoliday(market, luxDate) {
  luxDate = luxDate !== null && luxDate !== void 0 ? luxDate : (0, luxMarkets_1.luxMarket)(market).localTime();
  var ds = luxDate.toFormat('yyyy-LL-dd');
  return (0, luxMarkets_1.luxMarket)(market).halfHolidays.has(ds);
};
exports.isLuxHalfHoliday = isLuxHalfHoliday;
/**
 * @returns the most recent day with market data (ie NOT weekend or full-day holiday).
 */
var getPreviousMarketDate = function getPreviousMarketDate(market, luxDate) {
  luxDate = luxDate !== null && luxDate !== void 0 ? luxDate : (0, luxMarkets_1.luxMarket)(market).localTime();
  luxDate = luxDate.startOf('day').minus({
    day: 1
  });
  while ((0, exports.isLuxMarketClosed)(market, luxDate)) luxDate = luxDate.minus({
    day: 1
  });
  return luxDate;
};
exports.getPreviousMarketDate = getPreviousMarketDate;
var MarketStatus;
(function (MarketStatus) {
  MarketStatus["PreMarket"] = "PreMarket";
  MarketStatus["Open"] = "Open";
  MarketStatus["AfterMarket"] = "AfterMarket";
  MarketStatus["Closed"] = "Closed";
})(MarketStatus || (exports.MarketStatus = MarketStatus = {}));
/**
 * Uses BOTH the DAY and TIME of the given datetime (eg. 11pm on a Tueday will return Closed).
 * @param exchangeCode Used to determine the market's holidays, opening hours etc.
 * @param luxDate The DateTime to check the market status of. Will be converted to the market's timezone.
 */
var getMarketStatus = function getMarketStatus(exchangeCode, luxDate) {
  // Crypto market is always open
  if (exchangeCode === index_1.TrExchangeCode.crypto) return MarketStatus.Open;
  var _ref = (0, luxMarkets_1.exchangeToLuxMarket)(exchangeCode),
    localTime = _ref.localTime,
    toTimeOfDay = _ref.toTimeOfDay,
    marketCode = _ref.code;
  // make sure market hours are checked w/ a Datetime in the market's timezone
  var dateTime = localTime(luxDate);
  var isHalfDay = (0, exports.isLuxHalfHoliday)(marketCode, dateTime);
  if ((0, exports.isLuxMarketClosed)(marketCode, dateTime)) return MarketStatus.Closed;
  if (toTimeOfDay.preMarketOpen) {
    var preMarketOpen = toTimeOfDay.preMarketOpen(dateTime);
    if (dateTime < preMarketOpen) return MarketStatus.Closed;
  }
  if (toTimeOfDay.lateOpen && isHalfDay) {
    var lateStart = toTimeOfDay.lateOpen(dateTime);
    if (dateTime < lateStart) return MarketStatus.Closed;
  }
  var marketOpen = toTimeOfDay.open(dateTime);
  if (dateTime < marketOpen) return toTimeOfDay.preMarketOpen ? MarketStatus.PreMarket : MarketStatus.Closed;
  if (toTimeOfDay.earlyClose && isHalfDay) {
    var earlyClose = toTimeOfDay.earlyClose(dateTime);
    if (dateTime >= earlyClose) return MarketStatus.Closed;
  }
  var marketClose = toTimeOfDay.close(dateTime);
  if (dateTime < marketClose) return MarketStatus.Open;
  if (toTimeOfDay.afterMarketOpen) {
    var afterHoursOpen = toTimeOfDay.afterMarketOpen(dateTime);
    if (dateTime < afterHoursOpen) return MarketStatus.Closed;
  }
  if (toTimeOfDay.afterMarketClose) {
    var afterHoursClose = toTimeOfDay.afterMarketClose(dateTime);
    if (dateTime < afterHoursClose) return MarketStatus.AfterMarket;
  }
  return MarketStatus.Closed;
};
exports.getMarketStatus = getMarketStatus;
var getLastMarketDay = function getLastMarketDay(date) {
  var exchangeCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : index_1.TrExchangeCode.bzx;
  var shouldSearchForward = arguments.length > 2 ? arguments[2] : undefined;
  var isOneDayView = arguments.length > 3 ? arguments[3] : undefined;
  var useMondaySnapshots = arguments.length > 4 ? arguments[4] : undefined;
  var currentDate = date;
  var market = (0, luxMarkets_1.exchangeToLuxMarket)(exchangeCode);
  var currentDateObject = new Date(currentDate.toMillis());
  // this should only run for 1 day view
  if (isOneDayView) {
    // if the weekend, then set the currentDate to be that friday
    if (currentDateObject.getDay() === 0 || currentDateObject.getDay() === 6) {
      var endOfWeek = currentDate.endOf('week');
      currentDate = endOfWeek.minus({
        days: 2
      });
    } else if ((0, exports.isLuxHoliday)(market.code, currentDate)) {
      // check if holiday
      if (currentDateObject.getDay() === 1) {
        // we want to set the previous market day as Thursday if Monday is holiday
        currentDate = currentDate.minus({
          days: 3
        });
      } else {
        // we just set the currentDate to be 1 day back if Holiday but not Monday, i.e. if Tuesday, then set start date to Monday, and the logic below subtracts
        // one from the day, giving us Sunday and then finds the previous market day, which gives us Friday, which is the correct start date in this case
        currentDate = currentDate.minus({
          day: 1
        });
      }
    }
  }
  var previousMarketDateTime = (0, exports.getPreviousMarketDate)(market.code, currentDate);
  previousMarketDateTime = market.toTimeOfDay.close(previousMarketDateTime);
  var lastMarketDate = new Date(previousMarketDateTime.toMillis());
  if (shouldSearchForward) {
    var dayOfWeek = useMondaySnapshots ? 1 : 3;
    while (lastMarketDate.getDay() !== dayOfWeek) {
      lastMarketDate.setDate(lastMarketDate.getDate() + 1);
      if (!(0, exports.isLuxMarketClosed)(market.code, luxon_1.DateTime.fromJSDate(lastMarketDate, {
        zone: market.zone
      })) && lastMarketDate.getDay() === dayOfWeek) {
        break;
      }
    }
  }
  return lastMarketDate;
};
exports.getLastMarketDay = getLastMarketDay;
/**
 * getTodayMarketOpenClose
 * @param date this should be a DateTime object, like `luxEST()`
 * @param exchangeCode which exchange to use
 * @returns array of two dates, open and close toTimeOfDay for the last market day
 */
var getTodayMarketOpenClose = function getTodayMarketOpenClose(luxDate) {
  var exchangeCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : index_1.TrExchangeCode.bzx;
  var extendedHours = arguments.length > 2 ? arguments[2] : undefined;
  var _ref2 = (0, luxMarkets_1.exchangeToLuxMarket)(exchangeCode),
    localTime = _ref2.localTime,
    toTimeOfDay = _ref2.toTimeOfDay,
    marketCode = _ref2.code;
  var date = localTime(luxDate);
  var todayOpen = (0, exports.isLuxHalfHoliday)(marketCode, date) && toTimeOfDay.lateOpen ? toTimeOfDay.lateOpen(date) : toTimeOfDay.open(date);
  if ((0, exports.isLuxMarketClosed)(marketCode, date) || date < todayOpen) {
    // if today is a weekend or holiday, or the market day has not yet begun, return yesterday's hours
    date = (0, exports.getPreviousMarketDate)(marketCode, date);
  }
  var marketStart, marketEnd;
  if ((0, exports.isLuxHalfHoliday)(marketCode, date)) {
    // if date is a half holiday, return date's hours with a half holiday open/close toTimeOfDay
    marketStart = toTimeOfDay.lateOpen ? toTimeOfDay.lateOpen(date) : toTimeOfDay.open(date);
    marketEnd = toTimeOfDay.earlyClose ? toTimeOfDay.earlyClose(date) : toTimeOfDay.close(date);
  } else {
    // otherwise, return date with normal market hours
    if (extendedHours) {
      marketStart = toTimeOfDay.preMarketOpen ? toTimeOfDay.preMarketOpen(date) : toTimeOfDay.open(date);
      marketEnd = (toTimeOfDay === null || toTimeOfDay === void 0 ? void 0 : toTimeOfDay.afterMarketClose) ? toTimeOfDay === null || toTimeOfDay === void 0 ? void 0 : toTimeOfDay.afterMarketClose(date) : toTimeOfDay.close(date);
    } else {
      marketStart = toTimeOfDay.open(date);
      marketEnd = toTimeOfDay.close(date);
    }
  }
  return [marketStart, marketEnd];
};
exports.getTodayMarketOpenClose = getTodayMarketOpenClose;
/**
 *  provided a DateTime, will return a DateTime whose day is set to most recent market open day (prior to today)
 *  @param date this should be a DateTime object, like `luxEST()`
 *  @returns a DateTime
 */
var mostRecentMarketDay = function mostRecentMarketDay() {
  var dateTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, exports.luxEST)();
  var _getDay = function getDay(date) {
    var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
    if (!(0, exports.isLuxUSMarketClosed)(date) || maxDepth <= 0) return date;
    return _getDay(date = date.minus({
      days: 1
    }), maxDepth - 1);
  };
  return _getDay(dateTime.minus({
    days: 1
  }));
};
exports.mostRecentMarketDay = mostRecentMarketDay;
// These are for backwards compatiblity, dont add to them if you dont need to
var getUSMarketStatus = function getUSMarketStatus(dt) {
  return (0, exports.getMarketStatus)(index_1.TrExchangeCode.bzx, dt);
};
exports.getUSMarketStatus = getUSMarketStatus;
var getBrazilMarketStatus = function getBrazilMarketStatus(dt) {
  return (0, exports.getMarketStatus)(index_1.TrExchangeCode.sao, dt);
};
exports.getBrazilMarketStatus = getBrazilMarketStatus;
var getCAMarketStatus = function getCAMarketStatus(dt) {
  return (0, exports.getMarketStatus)(index_1.TrExchangeCode.tor, dt);
};
exports.getCAMarketStatus = getCAMarketStatus;
var getCryptoMarketStatus = function getCryptoMarketStatus(dt) {
  return (0, exports.getMarketStatus)(index_1.TrExchangeCode.crypto, dt);
};
exports.getCryptoMarketStatus = getCryptoMarketStatus;
var isLuxUSMarketClosed = function isLuxUSMarketClosed(dt) {
  return (0, exports.isLuxMarketClosed)('USA', dt);
};
exports.isLuxUSMarketClosed = isLuxUSMarketClosed;
var isLuxBrazilMarketClosed = function isLuxBrazilMarketClosed(dt) {
  return (0, exports.isLuxMarketClosed)('BRA', dt);
};
exports.isLuxBrazilMarketClosed = isLuxBrazilMarketClosed;
var isLuxCAMarketClosed = function isLuxCAMarketClosed(dt) {
  return (0, exports.isLuxMarketClosed)('CAN', dt);
};
exports.isLuxCAMarketClosed = isLuxCAMarketClosed;
var isLuxUSHoliday = function isLuxUSHoliday(dt) {
  return (0, exports.isLuxHoliday)('USA', dt);
};
exports.isLuxUSHoliday = isLuxUSHoliday;
var isLuxCAHoliday = function isLuxCAHoliday(dt) {
  return (0, exports.isLuxHoliday)('CAN', dt);
};
exports.isLuxCAHoliday = isLuxCAHoliday;
var isLuxUSEarlyClose = function isLuxUSEarlyClose(dt) {
  return (0, exports.isLuxHalfHoliday)('USA', dt);
};
exports.isLuxUSEarlyClose = isLuxUSEarlyClose;
var getPreviousUSMarketDate = function getPreviousUSMarketDate(dt) {
  return (0, exports.getPreviousMarketDate)('USA', dt);
};
exports.getPreviousUSMarketDate = getPreviousUSMarketDate;
var getPreviousSAOMarketDate = function getPreviousSAOMarketDate(dt) {
  return (0, exports.getPreviousMarketDate)('BRA', dt);
};
exports.getPreviousSAOMarketDate = getPreviousSAOMarketDate;